<template>
  <div>
    <div
      v-if="s.popup == 'contactedit'"
      id="popnew"
      class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
    >
      <ContactEdit @close="closeContact" />
    </div>
    <div
      v-if="s.popup"
      @click="close"
      id="overlay"
      class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
    ></div>

    <template v-if="touch.id > 0 && garland">
      <div class="flex max-xl:flex-col">
        <div class="w-[400px] my-4 max-xl:mx-auto max-xl:max-w-full">
          <div class="bg-white rounded-[4px]">
            <div class="p-4 v-bbgray">
              <div class="flex items-center w-full mb-4 relative">
                <h1 class="font-latobold text-xl text-black">КАСАНИЕ</h1>
              </div>
              <div class="flex items-center relative">
                <div class="w-16 h-16 relative">
                  <span
                    class="avatar w-full h-full flex items-center justify-center"
                    :class="{
                      'bg-status-1': touch.status == 1,
                      'bg-status-6': touch.status == 2,
                      'bg-status-9': touch.status == 3,
                      'bg-status-grey': touch.del == 1,
                    }"
                  >
                    <span
                      class="w-8 h-8 flex items-center justify-center first:!fill-white"
                    >
                      <IcoStatus :status="parseInt(touch.status)" />
                    </span>
                  </span>
                </div>
                <div class="flex flex-col ml-4">
                  <span
                    v-if="touch.status == 1"
                    class="text-gray-400 text-[10px] uppercase"
                    >Открытое</span
                  >
                  <span
                    v-if="touch.status == 2"
                    class="text-gray-400 text-[10px] uppercase"
                    >Закрытое</span
                  >
                  <span
                    v-if="touch.status == 3"
                    class="text-gray-400 text-[10px] uppercase"
                    >Отмененное</span
                  >

                  <span class="font-latobold text-xl text-black"
                    >№{{ touch.id }}</span
                  >
                </div>
              </div>
            </div>

            <div class="flex v-bbgray">
              <div class="brs1px flex w-[50%] py-5 pl-5 pr-4 items-center">
                <!-- <svg class="min-w-5 w-5 h-5 fill-gray-400 rotate-45 mr-2">
                                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                                </svg> -->
                <div class="flex flex-col">
                  <span class="text-gray-400 text-[10px] uppercase"
                    >СОЗДАН</span
                  >
                  <span class="font-latobold text-base text-gray-700">{{
                    moment(touch.created_at).format("DD.MM.YYYY в HH:mm")
                  }}</span>
                </div>
              </div>
              <div class="pl-4 py-5 pr-5px flex w-[50%] items-center">
                <div class="flex flex-col">
                  <span class="text-gray-400 text-[10px] uppercase"
                    >Откуда</span
                  >
                  <span class="font-latobold text-base text-gray-700">
                    {{ touch.comment }}
                  </span>
                </div>
              </div>
            </div>

            <!-- <div class="flex flex-wrap p-5 v-bbgray">
                            <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                                <input
                                    class="mychbox"
                                    type="checkbox"
                                    id="taho"
                                    v-model="touch.taho"
                                    @change="kindOfLead({ name: 'taho', val: touch.taho })"
                                />
                                <label for="taho">Тахограф</label>
                            </div>
                            <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                                <input
                                    class="mychbox"
                                    type="checkbox"
                                    id="monitor"
                                    v-model="touch.monitor"
                                    @change="kindOfLead({ name: 'monitor', val: touch.monitor })"
                                />
                                <label for="monitor">Мониторинг</label>
                            </div>
                            <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                                <input
                                    class="mychbox"
                                    type="checkbox"
                                    id="card"
                                    v-model="touch.card"
                                    @change="kindOfLead({ name: 'card', val: touch.card })"
                                />
                                <label for="card">Карты</label>
                            </div>
                            <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                                <input
                                    class="mychbox"
                                    type="checkbox"
                                    id="propusk"
                                    v-model="touch.propusk"
                                    @change="kindOfLead({ name: 'propusk', val: touch.propusk })"
                                />
                                <label for="propusk">Пропуска</label>
                            </div>
                            <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                                <input
                                    class="mychbox"
                                    type="checkbox"
                                    id="teach"
                                    v-model="touch.teach"
                                    @change="kindOfLead({ name: 'teach', val: touch.teach })"
                                />
                                <label for="teach">Обучение</label>
                            </div>
                        </div> -->
          </div>

          <div
            v-if="touch.business_proc"
            class="bg-white order-conn mt-4 relative rounded-[4px]"
          >
            <div class="flex p-5 v-bbgray">
              <div class="flex flex-col justify-center overflow-hidden pr-8">
                <span
                  class="text-gray-400 leading-none w-full max-w-[300px] mr-6 mb-1"
                  >БИЗНЕС ПРОЦЕСС</span
                >
                <select
                  @change="
                    clickedBP = true;
                    onChangeBP();
                  "
                  :disabled="touch.status != 1 && !specialRedact"
                  v-model="touch.business_proc"
                  class="select-bp v-bgray rounded-sm text-sm text-teal-700 w-full mt-2"
                  name=""
                  id=""
                >
                  <option value="0" disabled selected>Выберите опцию</option>
                  <option value="1">Пролонгация тахографы (СКЗИ)</option>
                  <option value="2">Пролонгация настройки ЕСТР</option>
                  <option value="3">Пролонгация пропуска</option>
                  <option value="4">Пролонгация карты</option>
                  <option value="5">Контроль качества</option>
                  <option value="6">Реанимация неактивных клиентов</option>
                  <option value="7">Реанимация клиентов без заказов</option>
                  <option value="8">Рекламации</option>
                  <option value="9">Как дела</option>
                  <option value="10">Общий</option>
                  <option value="11">АБ Мониторинг</option>
                  <option value="12">Агент</option>
                  <!-- <option value="13">Рекомендация</option>
                  <option value="14">Интернет</option> -->
                  <option value="15">Холодная база</option>
                </select>
                <!-- <span class="font-latobold text-base text-gray-700">Старт касания</span> -->
              </div>
            </div>
          </div>

          <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <div class="flex p-5 v-bbgray">
              <div
                v-if="touch.type"
                class="flex items-center group relative w-1/2"
              >
                <div
                  class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <span class="w-6 h-6 flex-cc"
                    ><IcoPic :pic="null" :name="String(touch.type)" />
                  </span>
                </div>
                <div class="flex flex-col justify-center overflow-hidden pr-8">
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >ВИД</span
                  >
                  <span class="font-latobold">
                    {{ type.find((item) => item.valueTy === touch.type).name }}
                  </span>
                </div>

                <a
                  v-if="touch.status == 1 || specialRedact"
                  class="group cursor-pointer opacity-0 group-hover:opacity-100"
                  @click="trySetLeadType(0)"
                >
                  <svg
                    class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                  >
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                </a>
              </div>
              <div
                v-if="touch.direction"
                class="flex items-center group relative w-1/2"
              >
                <div
                  class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <span
                    class="text-white text-xl w-11 h-11 leading-none rounded-full flex items-center justify-center"
                  >
                    <svg
                      class="w-5 h-5 fill-white"
                      :class="{ 'rotate-180': touch.direction == 2 }"
                    >
                      <use xlink:href="@/assets/i.svg#ico-next-one"></use>
                    </svg>
                  </span>
                </div>
                <div class="flex flex-col justify-center overflow-hidden pr-8">
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >НАПРАВЛЕНИЕ</span
                  >
                  <span class="font-latobold">{{
                    direction.find((item) => item.valueDir === touch.direction)
                      .name
                  }}</span>
                </div>

                <a
                  v-if="touch.status == 1 || specialRedact"
                  class="group cursor-pointer opacity-0 group-hover:opacity-100"
                  @click="trySetLeadDirection(0)"
                >
                  <svg
                    class="fill-gray-400 w-4 h-4 mr-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                  >
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                </a>
              </div>
            </div>
            <div v-if="!touch.type" class="p-5 v-bbgray">
              <div class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  ВИД
                </p>
                <select
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="touch.type"
                  @change="trySetLeadType(touch.type)"
                >
                  <!--<option value="0">Выбрать</option>-->
                  <option
                    v-for="val in type"
                    :value="val.valueTy"
                    :key="val.valueTy"
                    v-show="val.show"
                  >
                    {{ val.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="!touch.direction && touch.type" class="p-5 v-bbgray">
              <div class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  НАПРАВЛЕНИЕ
                </p>
                <select
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="touch.direction"
                  @change="trySetLeadDirection(touch.direction)"
                >
                  <!--<option value="0">Выбрать</option>-->
                  <option
                    v-for="val in direction"
                    :value="val.valueDir"
                    :key="val.valueDir"
                    v-show="val.show"
                  >
                    {{ val.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="canShowChannel" class="p-5 v-bbgray group relative">
              <div v-if="touch.channel" class="flex items-center">
                <div class="flex flex-col">
                  <p class="text-gray-400 text-[10px] uppercase">
                    КАНАЛ ПРИВЛЕЧЕНИЯ
                  </p>
                  <span class="font-latobold text-base text-gray-700">{{
                    channel.find((item) => item.valueCh === touch.channel).name
                  }}</span>
                </div>
                <div
                  v-if="touch.status == 1 || specialRedact"
                  class="absolute top-1/2 -translate-y-1/2 right-8 opacity-0 group-hover:opacity-100 transition-all duration-150"
                >
                  <a class="group cursor-pointer" @click="trySetLeadChannel(0)">
                    <svg
                      class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                    >
                      <use xlink:href="@/assets/i.svg#ico-no"></use>
                    </svg>
                  </a>
                </div>
              </div>
              <div v-else class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  КАНАЛ ПРИВЛЕЧЕНИЯ
                </p>
                <select
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="touch.channel"
                  @change="trySetLeadChannel(touch.channel)"
                >
                  <!--<option value="0">Выбрать</option>-->
                  <option
                    v-for="ch in channel"
                    :value="ch.valueCh"
                    :key="ch.valueCh"
                    v-show="ch.show"
                  >
                    {{ ch.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- <div
              class="p-5"
              style="display: flex; align-items: center"
              v-if="canShowChannelDetailType"
            >
              <p class="text-gray-400 leading-none w-full max-w-[200px] mr-6">
                ДЕТАЛИ КАНАЛА
              </p>
              <select
                v-model="touch.channel_detail_type"
                class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                @change="trySetLeadChannelDetailType(touch.channel_detail_type)"
              >
                <option
                  v-for="ch in availableChannelDetails"
                  :value="ch"
                  :key="ch"
                >
                  {{ channelDetailType[ch] }}
                </option>
              </select>
            </div>
            <div style="position: relative" v-if="canShowChannelDetailValue">
              <p
                class="text-gray-400 leading-none w-full p-5 mr-6"
                style="font-weight: 500; text-transform: uppercase"
              >
                Дополнительные данные:
              </p>
              <input
                type="text"
                v-model="touch.channel_detail_value"
                placeholder="Введите дополнительные сведения"
                style="
                  border: 1px solid #7b7b7b;
                  padding: 24px 18px;
                  padding-right: 50px;
                "
                class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                @change="setTouchChannelDetailValue(touch.channel_detail_value)"
              />
              <svg
                style="position: absolute; right: 15px; bottom: 11%"
                fill="#cccccc"
                height="20px"
                width="20px"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                enable-background="new 0 0 512 512"
              >
                <g>
                  <g>
                    <path
                      d="m455.1,137.9l-32.4,32.4-81-81.1 32.4-32.4c6.6-6.6 18.1-6.6 24.7,0l56.3,56.4c6.8,6.8 6.8,17.9 0,24.7zm-270.7,271l-81-81.1 209.4-209.7 81,81.1-209.4,209.7zm-99.7-42l60.6,60.7-84.4,23.8 23.8-84.5zm399.3-282.6l-56.3-56.4c-11-11-50.7-31.8-82.4,0l-285.3,285.5c-2.5,2.5-4.3,5.5-5.2,8.9l-43,153.1c-2,7.1 0.1,14.7 5.2,20 5.2,5.3 15.6,6.2 20,5.2l153-43.1c3.4-0.9 6.4-2.7 8.9-5.2l285.1-285.5c22.7-22.7 22.7-59.7 0-82.5z"
                    />
                  </g>
                </g>
              </svg>
            </div> -->

            <div class="p-5" v-if="canShowCommunicationType">
              <p
                class="text-gray-400 leading-none w-full max-w-[300px] mr-6 mb-3"
              >
                ВИД КОММУНИКАЦИИ
              </p>
              <!--<select
                                v-model="touch.communication_type"
                                class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                                @change="setTouchCommunicationType(touch.communication_type)"
                            >
                                <option value="0">Выбрать</option>
                                <option v-for="ch in availableCommunicationTypes" :value="ch" :key="ch">{{ communications[ch] }}</option>
                            </select>-->
              <!-- <ul v-if="touch.communication_type == 13">
                <li class="mb-1">
                  <input type="radio" checked="true" />
                  <span class="ml-2">Заявка с сайта</span>
                </li>
              </ul> -->
              <ul v-if="touch.channel == 1 || touch.channel == 2">
                <li class="mb-1" v-for="ch in communications" :key="ch">
                  <input
                    type="radio"
                    :disabled="touch.status != 1 && !specialRedact"
                    :value="ch.value"
                    v-model="touch.communication_type"
                    v-show="ch.show"
                    @change="
                      setTouchCommunicationType(touch.communication_type)
                    "
                  />
                  <span v-show="ch.show" class="ml-2">{{ ch.name }}</span>
                </li>
              </ul>
              <ul v-else-if="touch.channel == 3">
                <li class="mb-1" v-for="ch in communications" :key="ch">
                  <input
                    type="radio"
                    checked
                    :disabled="touch.status != 1 && !specialRedact"
                    :value="ch.value"
                    v-model="touch.communication_type"
                    v-show="ch.show"
                    @change="
                      setTouchCommunicationType(touch.communication_type)
                    "
                  />
                  <span v-show="ch.show" class="ml-2">{{ ch.name }}</span>
                </li>
              </ul>
              <ul v-else>
                <template v-for="ch in communications">
                  <li class="mb-1" v-if="ch.value != 13" :key="ch">
                    <input
                      type="radio"
                      :disabled="touch.status != 1 && !specialRedact"
                      :value="ch.value"
                      v-model="touch.communication_type"
                      v-show="ch.show"
                      @change="
                        setTouchCommunicationType(touch.communication_type)
                      "
                    />
                    <span v-show="ch.show" class="ml-2">{{ ch.name }}</span>
                  </li>
                </template>
              </ul>
            </div>
            <!--<div class="p-5 v-bbgray group relative">
                            <div v-if="touch.detail" class="flex items-center">
                                <div class="flex flex-col">
                                    <p class="text-gray-400 text-[10px] uppercase">ДЕТАЛИ</p>
                                    <span class="font-latobold text-base text-gray-700">{{ detail[touch.detail] }}</span>
                                </div>

                                <div class="absolute top-1/2 -translate-y-1/2 right-8 opacity-0 group-hover:opacity-100 transition-all duration-150">
                                    <a class="group cursor-pointer" @click="setLeadDetail(0)">
                                        <svg class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150">
                                            <use xlink:href="@/assets/i.svg#ico-no"></use>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div v-else class="flex items-center w-full">
                                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">ДЕТАЛИ</p>
                                <select
                                    class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                                    v-model="touch.detail"
                                    @change="setLeadDetail(touch.detail)"
                                >
                                    <option value="">Выбрать</option>
                                    <option v-for="(val, key) in detail" :key="val" :value="key">{{ val }}</option>
                                </select>
                            </div>
                        </div>-->
          </div>
          <div
            v-if="canShowClient"
            class="rounded-[4px] bg-white mt-4 relative order-conn"
          >
            <template v-if="touch.client_id != null">
              <template v-if="touch.client?.loader">
                <div class="flex">
                  <img src="https://api.tahocrm.ru/images/loader.svg" />
                </div>
              </template>
              <template v-else>
                <div class="flex relative group miw-w-full p-5 v-bbgray">
                  <a
                    class="flex items-center cursor-pointer group max-w-[75%]"
                    @click="showClient(touch.client)"
                  >
                    <div
                      class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                    >
                      <span class="w-6 h-6 flex-cc">
                        <IcoPic
                          :pic="touch.client?.picture"
                          :name="touch.client?.name"
                        />
                      </span>
                    </div>
                    <div
                      class="flex flex-col justify-center overflow-hidden pr-8"
                    >
                      <span
                        class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                        >Клиент</span
                      >
                      <span
                        class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                        >{{ touch.client?.name }}</span
                      >
                    </div>
                  </a>

                  <div
                    v-if="
                      ['Manager', 'Studio', 'Hosd'].includes(role) &&
                      [1, 10].includes(touch.status)
                    "
                    class="absolute top-1/2 -translate-y-1/2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-150"
                  >
                    <a class="cursor-pointer" @click="dClient">
                      <svg
                        class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                      >
                        <use xlink:href="@/assets/i.svg#ico-no"></use>
                      </svg>
                    </a>
                  </div>
                </div>
              </template>
            </template>

            <div v-else class="p-5">
              <div v-if="canEditClient" class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  КЛИЕНТ
                </p>
                <div class="flex-1 relative">
                  <input
                    type="text"
                    v-model.trim="text_client"
                    class="bg-slate-50 h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                    @click="findLeadClient(text_client)"
                    @input="findLeadClient(text_client)"
                  />
                  <div
                    class="absolute w-full top-full bg-white left-0 rounded-b-lg border border-green-500 border-t-0 z-10 hidden"
                    :class="{ '!block': selectLeadClients?.length > 0 }"
                  >
                    <div
                      v-for="cl in selectLeadClients"
                      :key="cl"
                      @click="setLeadClient(cl.id), (text_client = '')"
                      class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                    >
                      <span>{{ cl.name }}</span>
                      <span class="text-xs">{{ cl.iid }}</span>
                    </div>
                  </div>
                  <div
                    v-if="
                      text_client.length > 0 && selectLeadClients?.length <= 0
                    "
                    class="absolute w-full top-full bg-white left-0 rounded-b-lg border border-green-500 border-t-0 z-10 block"
                  >
                    <div
                      class="px-4 py-2 flex justify-between items-center hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                    >
                      <span>НЕ&nbsp;НАЙДЕН</span>
                      <button class="v-btn bg-green-500 hover:bg-green-400">
                        <span
                          class="v-btn_text flex items-center"
                          @click="
                            addLeadClient(text_client), (text_client = '')
                          "
                        >
                          <svg
                            class="fill-white w-16px h-16px mr-2 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linea"
                          >
                            <use xlink:href="/img/i.5cce8585.svg#ico-no"></use>
                          </svg>
                          СОЗДАТЬ
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <p v-else class="text-rose-400 leading-none text-center">
                Клиент не добавлен!
              </p>
            </div>

            <template v-if="touch.client_id != null">
              <div class="p-5 v-bbgray flex items-center group relative">
                <template v-if="touch.contact_id != null">
                  <template v-if="touch.contact?.loader">
                    <div class="flex">
                      <img src="https://api.tahocrm.ru/images/loader.svg" />
                    </div>
                  </template>
                  <template v-else>
                    <a
                      class="flex cursor-pointer group"
                      @click="showContactfromLead(touch.contact)"
                    >
                      <div
                        class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                      >
                        <span class="w-6 h-6 flex-cc">
                          <IcoPic
                            :pic="touch.contact?.picture"
                            :name="touch.contact?.name"
                          />
                        </span>
                      </div>
                      <div
                        class="flex flex-col justify-center overflow-hidden pr-8"
                      >
                        <span
                          class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                          >Контакт</span
                        >
                        <span
                          class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                          >{{ touch.contact?.secondname }}
                          {{ touch.contact?.name }}</span
                        >
                      </div>
                    </a>
                    <template v-if="touch.contact?.phone">
                      <a
                        class="rounded-full absolute top-1/2 -translate-y-1/2 right-16 w-7 h-7 hover:w-36 overflow-hidden flex items-center bg-green-500 transition-all duration-300"
                        :href="'tel:' + touch.contact.phone"
                      >
                        <svg class="w-4 h-4 ml-[6px] fill-white">
                          <use xlink:href="@/assets/i.svg#ico-phone"></use>
                        </svg>
                        <span class="absolute left-7 p-1 text-white">{{
                          touch.contact?.phone
                        }}</span>
                      </a>
                    </template>
                    <div
                      v-if="
                        ['Manager', 'Studio', 'Hosd'].includes(role) &&
                        touch.contact_id &&
                        [1].includes(touch.status)
                      "
                      class="absolute top-1/2 -translate-y-1/2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-150"
                    >
                      <a
                        class="group cursor-pointer"
                        @click="delTouchContact()"
                      >
                        <svg
                          class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                        >
                          <use xlink:href="@/assets/i.svg#ico-no"></use>
                        </svg>
                      </a>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div
                    v-if="
                      ['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(
                        role
                      ) &&
                      selectTouchContacts &&
                      selectTouchContacts.length > 0
                    "
                    class="flex items-center w-full"
                  >
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      Выберите контакт
                    </p>
                    <div class="relative w-full">
                      <input
                        type="text"
                        v-model.trim="text_contact"
                        class="bg-slate-50 h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                        @input="findContact()"
                        @click="findContact()"
                      />
                      <div
                        v-if="contactList && contactList.length > 0"
                        class="absolute w-full top-full bg-white left-0 border-2 border-green-800 border-t-0 z-10"
                      >
                        <div
                          v-for="co in contactList"
                          :key="co"
                          @click="pickContact(co)"
                          class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                        >
                          <span>{{ co.secondname }} {{ co.name }}</span>
                          <span class="text-xs">{{ co.position }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-else class="text-rose-500 text-sm">
                    Контакт не добавлен!
                  </p>
                </template>
              </div>

              <!-- <div class="p-5 v-bbgray">
                <div v-if="touch.client?.business" class="flex items-center">
                  <div class="flex flex-col">
                    <p class="text-gray-400 text-[10px] uppercase">
                      Направление
                    </p>
                    <span
                      v-if="touch.client?.business != 5"
                      class="font-latobold text-base text-gray-700"
                    >
                      {{ b[touch.client?.business] }}
                    </span>
                    <span v-else class="font-latobold text-base text-gray-700">
                      {{ touch.client?.business_dop }}
                    </span>
                  </div>
                </div>
                <template v-else>
                  <div class="flex items-center w-full">
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      Направление
                    </p>
                    <select
                      class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                      v-model="business"
                      @change="
                        setClientBusiness({
                          business: business,
                          business_dop: null,
                        })
                      "
                    >
                      <option value="0">Выбрать</option>
                      <option v-for="(val, key) in b" :key="val" :value="key">
                        {{ val }}
                      </option>
                    </select>
                  </div>

                  <template v-if="business == 5">
                    <div class="flex items-center w-full">
                      <p
                        class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                      >
                        КОММЕНТАРИЙ
                      </p>
                      <input
                        class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                        type="text"
                        placeholder="Впишите сферу бизнеса"
                        v-model="business_dop"
                      />
                    </div>
                    <button
                      class="v-btn v-btn--sm bg-green-500 hover:bg-green-400 ml-auto mt-2"
                      @click="
                        setClientBusiness({
                          business: 5,
                          business_dop: business_dop,
                        })
                      "
                    >
                      <span class="v-btn_text flex items-center"
                        >СОХРАНИТЬ</span
                      >
                    </button>
                  </template>
                </template>
              </div>

              <div class="p-5 v-bbgray">
                <div v-if="touch.client?.ts" class="flex items-center">
                  <div class="flex flex-col">
                    <p class="text-gray-400 text-[10px] uppercase">КОЛ-ВО ТС</p>
                    <span class="font-latobold text-base text-gray-700">
                      {{ touch.client?.ts }}
                    </span>
                  </div>
                </div>
                <template v-else>
                  <div class="flex items-center w-full">
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      КОЛ-ВО ТС <br />У КЛИЕНТА
                    </p>

                    <input
                      class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                      type="text"
                      v-model="ts"
                      @change="setClientTs(ts)"
                    />
                  </div>
                </template>
              </div> -->
            </template>
          </div>

          <div
            class="bg-white order-conn mt-4 p-5 relative rounded-[4px]"
            v-if="canAddClient"
          >
            <div style="position: relative" v-if="touch.client_id">
              <a
                @click="editNewClient"
                class="flex items-center cursor-pointer group max-w-[75%]"
              >
                <div
                  class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <span class="w-6 h-6 flex-cc">
                    <span
                      class="text-white text-xl w-11 h-11 leading-none rounded-full flex items-center justify-center"
                      >К</span
                    >
                  </span>
                </div>
                <div class="flex flex-col justify-center overflow-hidden pr-8">
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >Карточка клиента</span
                  >
                  <span
                    class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                    >{{ touch?.client?.name }}</span
                  >
                </div>
              </a>
              <!-- <a class="cursor-pointer" style="position: absolute; right: 0; top: calc(50% - 8px);" @click="dClient">
                            <svg class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150">
                                <use xlink:href="@/assets/i.svg#ico-no"></use>
                            </svg>
                        </a> -->
            </div>

            <!--                         
                        <div v-if="touch.client_id" class="v-btn v-btn--sm bg-green-500 hover:bg-green-400" style="cursor: pointer;" @click="editNewClient">    
                            <span style="font-weight: 600; font-size: 14px; color: #fff;">{{ touch.client.name }}</span>
                        </div> -->
            <div v-else>
              <button
                @click="addNewClient"
                class="v-btn v-btn--sm bg-green-500 hover:bg-green-400"
              >
                <span class="v-btn_text flex items-center">
                  <svg
                    class="fill-white w-16px h-16px mr-3 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linear"
                  >
                    <use xlink:href="/img/i.cc1a44ec.svg#ico-no"></use>
                  </svg>
                  <span>Добавить клиента</span>
                </span>
              </button>
              <!-- <button @click="addNewClient">Добавить клиента</button> -->
            </div>
            <div
              v-if="showClientEdit"
              id="popnew"
              class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
            >
              <ClientEdit @close="clientEditClose" />
            </div>
          </div>

          <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <!-- <div v-if="touch.manager_id" class="p-5 v-bbgray">
                        <div class="flex items-center cursor-pointer group">
                            <div class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 overflow-hidden bg-green-500">
                                <span class="w-6 h-6">
                                    <IcoPic :pic="touch.upicture" :name="touch.uname" />
                                </span>
                            </div>
                            <div class="flex flex-col justify-center overflow-hidden pr-8">
                                <span class="text-[10px] text-gray-400 leading-none uppercase mb-1">Менеджер</span>
                                <span class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                                    >{{ touch.uname }} {{ touch.usecondname }}</span
                                >
                            </div>
                        </div>
                    </div> -->

            <div
              v-if="['Manager', 'Studio', 'Hosd', 'Check'].includes(role)"
              class="flex relative group p-5 v-bbgray"
            >
              <div v-if="touch.manager_id" class="flex justify-between">
                <div class="flex items-center cursor-pointer group">
                  <div
                    class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 overflow-hidden bg-green-500"
                  >
                    <span class="w-6 h-6">
                      <IcoPic :pic="touch.upicture" :name="touch.uname" />
                    </span>
                  </div>
                  <div
                    class="flex flex-col justify-center overflow-hidden pr-8"
                  >
                    <span
                      class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                      >Менеджер</span
                    >
                    <span
                      class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                      >{{ touch.uname }} {{ touch.usecondname }}</span
                    >
                  </div>
                </div>
                <div
                  v-if="touch.manager_id && [1, 3].includes(touch.status)"
                  class="absolute top-1/2 -translate-y-1/2 right-8 opacity-0 group-hover:opacity-100 transition-all duration-150"
                >
                  <!-- <a class="group cursor-pointer" @click="delLeadManager()">
                                        <svg class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150">
                                            <use xlink:href="@/assets/i.svg#ico-no"></use>
                                        </svg>
                                    </a> -->
                </div>
              </div>

              <template v-else>
                <div class="flex items-center w-full">
                  <p
                    class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                  >
                    Менеджер
                  </p>
                  <div class="relative w-full">
                    <input
                      type="text"
                      v-model.trim="text_manager"
                      class="bg-white h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                      @input="findManager()"
                      @click="findManager()"
                    />
                    <div
                      v-if="managerList.length"
                      class="absolute w-full top-full bg-white left-0 border-2 border-green-800 border-t-0 z-10"
                    >
                      <div
                        v-for="m in managerList"
                        :key="m"
                        @click="setLeadManager(m)"
                        class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                      >
                        <span>{{ m.secondname }} {{ m.name }}</span>
                        <span class="text-xs">{{ m.uid }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="flex relative group p-5 v-bbgray">
              <div v-if="touch.who" class="flex justify-between">
                <div class="flex items-center cursor-pointer group">
                  <div
                    class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 overflow-hidden bg-green-500"
                  >
                    <span class="w-6 h-6">
                      <IcoPic :pic="touch.wpicture" :name="touch.wname" />
                    </span>
                  </div>
                  <div
                    class="flex flex-col justify-center overflow-hidden pr-8"
                  >
                    <span
                      class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                      >СОЗДАТЕЛЬ</span
                    >
                    <span
                      class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                      >{{ touch.wname }} {{ touch.wsecondname }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col ml-4 mr-12 flex-1 mb-4 max-l:mx-0">
          <div
            v-if="
              ['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role) &&
              showGarland == true
            "
            class="flex justify-between border-t-2 border-gray-400 w-[90%] mt-10 mb-1 mx-auto max-m:hidden"
          >
            <div class="flex flex-col items-center -mt-6 -ml-6">
              <span
                class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#nav-clients"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >КАСАНИЕ</span
              >
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showLeads')"
                class="rounded-full h-11 w-11 bg-gray-400 flex items-center justify-center"
                :class="{
                  '!bg-status-5': garland.leads.length > 0,
                  '!bg-status-7': touch.status == 3,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#status-1"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЛИД</span
              >

              <div
                v-if="showLeads && garland.leads.length > 0"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Лиды из касания
                </p>
                <a
                  v-for="lead in garland.leads"
                  :key="lead"
                  @click="goToLead(lead.id)"
                  >№{{ lead.id }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showZayavka')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.bids.length > 0,
                  '!bg-status-7': touch.status == 3,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#doc"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЗАЯВКА</span
              >

              <div
                v-if="showZayavka && garland.bids.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Заявки из касания
                </p>
                <a
                  v-for="bid in garland.bids"
                  @click="goToBid(bid.id)"
                  :key="bid"
                  >№{{ bid.id }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showSchet')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.invoices.length,
                  '!bg-status-7': touch.status == 3,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#doc"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >СЧЕТ</span
              >

              <div
                v-if="showSchet && garland.invoices.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Счета из касания
                </p>
                <a
                  v-for="invoice in garland.invoices"
                  @click="goToInvoice(invoice.id)"
                  :key="invoice"
                  >{{ invoice.invoice_number }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showOrderLet')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.orders.length,
                  '!bg-status-7': touch.status == 3,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#pay-1"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЗАКАЗ</span
              >
              <div
                v-if="showOrderLet && garland.orders.length"
                class="absolute-list last-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Заказы из касания
                </p>
                <a
                  v-for="order in garland.orders"
                  @click="goToOrder(order.id)"
                  :key="order"
                  >№{{ order.iid }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 -mr-6 relative">
              <span
                @click="toggleGarl('showAnketa')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.anketas.length,
                  '!bg-status-7': touch.status == 3,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#pay-2"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >АНКЕТА</span
              >

              <div
                v-if="showAnketa && garland.anketas.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Анкеты из касания
                </p>
                <a v-for="anketa in garland.anketas" :key="anketa"
                  >№{{ anketa.id }}</a
                >
              </div>
            </div>
          </div>
          <!-- <div class="p-5 bg-white rounded-[4px] mt-4">
                        <div class="flex justify-between items-center max-l:flex-wrap">
                            <div class="max-w-[50%] w-full flex items-center">
                                <span
                                    class="rounded-full h-11 min-w-[2.75rem] w-11 bg-status-1 flex items-center justify-center mr-4 overflow-hidden"
                                >
                                    <svg class="w-5 h-5 fill-white"><use xlink:href="/img/i.cc1a44ec.svg#nav-service"></use></svg>
                                </span>
                                <span class="text-base font-latobold">СУММА ЗАЯВКИ</span>
                            </div>
                            <div v-if="touch.sum" class="flex justify-between items-center">
                                <div class="text-base font-latobold">{{ touch.sum }}&nbsp;₽</div>
                                <a class="group cursor-pointer ml-4" @click="setLeadSum(0), (sum = 0)">
                                    <svg class="fill-gray-400 w-4 h-4 group-hover:fill-rose-500 transition-colors duration-300">
                                        <use xlink:href="@/assets/i.svg#ico-no"></use>
                                    </svg>
                                </a>
                            </div>

                            <template v-else>
                                <div class="flex items-center w-full">
                                    <input
                                        class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                                        type="text"
                                        v-model="sum"
                                        @change="setLeadSum(sum)"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>


                    <div class="p-5 bg-white rounded-[4px] mt-4">
                        <div class="flex items-center max-l:flex-wrap">
                            <div class="flex items-center max-l:flex-wrap">
                                <span class="text-base font-latobold uppercase">Событие в 1С</span><br/>
                                <div class="flex items-center w-full">
                                    <textarea
                                        class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                                        v-model="touch.event_one_s"
                                        @change="setEvent1S(touch.event_one_s)"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div> -->

          <div class="double-flex">
            <div class="w-[50%] mr-2 p-5 bg-white rounded-[4px] mt-4">
              <div class="flex items-center max-l:flex-wrap">
                <div class="flex items-center max-l:flex-wrap">
                  <span
                    class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                  >
                    <svg class="fill-white w-5 h-5">
                      <use xlink:href="@/assets/i.svg#ico-timer"></use>
                    </svg>
                  </span>
                  <span class="text-base font-latobold uppercase"
                    >Задачи:
                  </span>
                  <div class="flex flex-wrap">
                    <div
                      v-for="item in touch.tasks"
                      :key="item"
                      class="preview ml15"
                    >
                      <a
                        class="ml-2 text-base font-latobold cursor-pointer hover:text-green-500 transition-colors duration-300"
                        :class="statusClasses[item.status]"
                        :title="altStatus[item.status]"
                        @click="showTask(item)"
                        >№{{ item.iid }}</a
                      >
                    </div>
                  </div>
                </div>

                <button
                  class="v-btn v-btn--sm bg-green-500 hover:bg-green-400 ml-auto"
                >
                  <span
                    class="v-btn_text flex items-center"
                    @click="
                      tryAddTask({
                        object: 'touch',
                        oid: touch.id,
                        type: 105,
                        department: 1,
                      })
                    "
                  >
                    <svg
                      class="fill-white w-16px h-16px mr-3 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linear"
                    >
                      <use xlink:href="@/assets/i.svg#ico-no"></use>
                    </svg>
                    <span>ЗАДАЧА</span>
                  </span>
                </button>
              </div>
            </div>

            <div class="w-[50%] ml-2 p-5 bg-white rounded-[4px] mt-4">
              <div class="flex items-center max-l:flex-wrap">
                <div class="flex items-center max-l:flex-wrap">
                  <span
                    class="rounded-full h-11 min-w-[2.75rem] w-11 bg-blue-500 flex items-center justify-center mr-4"
                  >
                    <svg class="fill-white w-5 h-5">
                      <use xlink:href="@/assets/i.svg#ico-phone"></use>
                    </svg>
                  </span>
                  <div>
                    <!-- <div class="flex align-center">
                      <span class="text-base font-latobold uppercase"
                        >Имя:
                      </span>
                      <span
                        v-if="touch.contact?.secondname && touch.contact?.name"
                        class="text-base font-latobold uppercase ml-4"
                        >{{ touch.contact?.secondname }}
                        {{ touch.contact?.name }}
                      </span>
                      <span
                        v-else
                        class="text-base font-latobold uppercase ml-4"
                        >Иванов Иван
                      </span>
                    </div> -->
                    <div class="flex align-center">
                      <span class="text-base font-latobold uppercase"
                        >Телефония:
                      </span>

                      <span class="text-base font-latobold uppercase ml-4"
                        >8 800 000 00 00</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-5 bg-white mt-4 rounded-[4px]">
            <CommentList
              :id="parseInt(touch.id)"
              :iid="parseInt(touch.iid)"
              type="touch"
            />
          </div>

          <div v-if="touch.del == 1" class="p-5 bg-white mt-4 rounded-[4px]">
            <div class="flex items-center">
              <div
                class="min-w-[1.5rem] w-7 h-7 rounded-full bg-rose-500 flex items-center justify-center mr-4"
              >
                <svg class="w-4 h-4 fill-white">
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </div>
              <div>
                <span class="blocktext-xs text-gray-800 font-latobold"
                  >Касание было удалено!</span
                >
              </div>
            </div>
          </div>

          <div
            v-if="otkaz || touch.status == 3"
            class="p-5 bg-white mt-4 rounded-[4px]"
          >
            <div v-if="touch.status == 3" class="flex items-center">
              <div
                class="min-w-[1.5rem] w-7 h-7 rounded-full bg-rose-500 flex items-center justify-center mr-4"
              >
                <svg class="w-4 h-4 fill-white">
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </div>
              <div>
                <span class="blocktext-xs text-gray-800 font-latobold">{{
                  cancel[touch.cancel_id]
                }}</span>
                <span
                  v-if="touch.cancel_comment"
                  class="blocktext-xs text-gray-800 font-latobold block"
                  >{{ touch.cancel_comment }}</span
                >
              </div>
            </div>

            <div v-else class="flex flex-col justify-center">
              <h3 class="text-red-500 text-center">Укажите причину отказа</h3>
              <select
                class="w-full px-4 py-2 bg-white v-bgray rounded-md mb-3"
                v-model="cancel_id"
              >
                <option value="0" disabled selected>Выбрать причину</option>
                <option :value="key" v-for="(val, key) in cancel" :key="val">
                  {{ val }}
                </option>
              </select>
              <textarea
                type="text"
                class="w-full px-4 py-2 bg-white v-bgray rounded-md"
                v-model="touch.cancel_comment"
                placeholder="Комментарий"
              ></textarea>
              <button
                v-if="parseInt(cancel_id) > 0"
                class="v-btn v-btn--sm v-btn--sm bg-green-500 hover:bg-green-400 ml-auto mt-3"
                @click="
                  sendTouchCancel({
                    cancel_id: cancel_id,
                    comment: touch.cancel_comment,
                  })
                "
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-16px h-16px mr-3">
                    <use xlink:href="@/assets/i.svg#ico-telegram"></use>
                  </svg>
                  <span>ОТПРАВИТЬ</span>
                </span>
              </button>
            </div>
          </div>

          <div class="flex justify-around mt-4">
            <template
              v-if="
                ['Manager', 'Studio', 'Hosd'].includes(role) &&
                [1].includes(touch.status) &&
                touch.del != 1
              "
            >
              <button
                class="v-btn v-btn--sm bg-emerald-600 hover:bg-emerald-500"
                @click="tryCreateOrder"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#nav-flow"></use>
                  </svg>
                  <span>Создать лид</span>
                </span>
              </button>
            </template>

            <template v-if="['Studio'].includes(role) && !specialRedact">
              <button
                class="v-btn v-btn--sm bg-blue-600 hover:bg-emerald-500"
                @click="specialRedact = true"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#nav-flow"></use>
                  </svg>
                  <span>Разрешить редактирование</span>
                </span>
              </button>
            </template>

            <template v-if="['Studio'].includes(role) && specialRedact">
              <button
                class="v-btn v-btn--sm bg-red-600 hover:bg-emerald-500"
                @click="tryChangeAllFunc"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#nav-flow"></use>
                  </svg>
                  <span>Каскадное изменение</span>
                </span>
              </button>
            </template>

            <template
              v-if="
                ['Manager', 'Studio', 'Hosd'].includes(role) &&
                ![2, 3].includes(touch.status) &&
                !otkaz &&
                touch.del != 1
              "
            >
              <button
                class="v-btn v-btn--sm bg-gray-400 hover:bg-gray-300"
                @click="tryCansel"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                  <span>Отказ</span>
                </span>
              </button>
            </template>

            <!-- <template v-if="['Manager', 'Studio' , 'Hosd'].includes(role) && ![3].includes(touch.status) && !otkaz && touch.del != 1">
                            <button class="v-btn v-btn--sm bg-rose-500 hover:bg-rose-400" @click="tryDelLead">
                                <span class="v-btn_text flex items-center">
                                    <svg class="fill-white w-4 h-4 mr-3">
                                        <use xlink:href="@/assets/i.svg#ico-delete"></use>
                                    </svg>
                                    <span>Удалить касание</span>
                                </span>
                            </button>
                        </template> -->
          </div>
        </div>
      </div>

      <div
        v-if="s.popup == 'task'"
        id="popnew"
        class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-max overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
      >
        <TaskEdit @close="close" />
      </div>

      <div
        v-if="s.popup"
        @click="close"
        id="overlay"
        class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
      ></div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ClientEdit from "../components/client/ClientEdit";
import ContactEdit from "../components/client/ContactEdit";
import CommentList from "../components/CommentList.vue";
import IcoPic from "../components/ui/IcoPic.vue";
import IcoStatus from "../components/ui/IcoStatus.vue";

// const com = {
//   5: true, //Звонок
//   6: true, //Письмо
//   7: true, //Пришел в офис
//   10: true, //Заявка через ЛК агента СРМ
//   // 13: true, // "Заявка с сайта",
// };
// const com1 = {
//   5: true, //Звонок
//   6: true, //Письмо
//   10: true, //Заявка через ЛК агента СРМ
//   // 13: true, // "Заявка с сайта",
// };
// const vt_is2 = {
//   5: true, //Звонок
//   // 12: true, //заявка с рейтингом более 7
// };

// const nv_vh1 = {
//   1: true,
//   2: true,
//   3: true,
//   4: true,
// };
// const nv_vh2 = {
//   5: true,
//   6: true,
//   7: true,
// };
// const nv_vh3 = {
//   8: true,
// };
// const nv_is = {
//   5: true,
//   9: true,
// };

// const leadsByOther = {
//   1: {
//     //ПЕРВИЧНЫЙ
//     1: {
//       //ВХОДЯЩИЙ
//       1: {
//         //Интернет
//         0: nv_vh1 /*{
//                     1: true,
//                     2: true,
//                 }*/,
//       },
//       2: {
//         //Рекомендация
//         0: nv_vh2 /*{
//                4: true,
//                5: true,
//            }*/,
//       },
//       3: {
//         //Агент
//         0: nv_vh3 /*{
//                5: true,
//                6: true,
//                7: true,
//            }*/,
//       },
//     },
//     2: {
//       //ИСХОДЯЩИЙ
//       15: {
//         //Агент
//         0: nv_is /*{
//                5: true,
//                6: true,
//                7: true,
//            }*/,
//       },
//     },
//   },

//   2: {
//     //ВТОРИЧНЫЙ
//     1: {
//       //ВХОДЯЩИЙ
//       21: {
//         //Вторичная клиентская база
//         /*1: {//Наименование клиента
//                     5: true, //Звонок
//                     6: true, //Письмо
//                     7: true, //Пришел в офис
//                     8: true, //Заявка через ЛК агента СРМ
//                 },
//                 6: {//Обзвон клиентов по контролю качества
//                     12: true, //Заявка из отзыва с рейтингом
//                 }*/
//         0: com,
//       },
//       22: {
//         //Рассылка
//         /*2: {//Ниатменование рассылки
//                5: true, //Звонок
//                6: true, //Письмо
//                8: true, //Заявка через ЛК агента СРМ
//            },
//            6: {//Обзвон клиентов по контролю качества
//                12: true, //Заявка из отзыва с рейтингом
//            }*/
//         0: com1,
//       },
//       23: {
//         //Агент-сотрудник
//         3: {
//           //ФИО агента-сотрудника
//           11: true, //Заявка через ЛК агента СРМ
//         },
//       },
//     },
//     2: {
//       21: {
//         0: vt_is2,
//       },
//     },
//   },
// };

// function extract(o, k, ...p) {
//   var v = o[k];
//   if (!v) {
//     var s = new Set();
//     Object.values(o).forEach((x) => {
//       if (p.length) {
//         extract(x, ...p).forEach((a) => s.add(a));
//       } else {
//         Object.keys(x).forEach((a) => s.add(a));
//       }
//     });
//     return [...s];
//   }
//   if (p.length) return extract(v, ...p);
//   else return Object.keys(v);
// }
const statusClasses = {
  1: "new_lead_task",
  2: "robot_lead_task",
  3: "appoint_lead_task",
  4: "started_lead_task",
  5: "done_lead_task",
  6: "finished_lead_task",
  7: "violate_lead_task",
  19: "violate_lead_task",
};
export default {
  name: "TouchEdit",

  components: { ContactEdit, CommentList, IcoPic, IcoStatus, ClientEdit },

  data() {
    return {
      specialRedact: false,
      showLeads: false,
      showZayavka: false,
      showSchet: false,
      showAnketa: false,
      showOrder: false,
      showOrderLet: false,
      showGarland: false,

      clickedBP: false,
      altStatus: {
        1: "Черновик",
        2: "Новая",
        3: "Назначена",
        4: "Начата",
        5: "Выполнена",
        6: "Завершена",
        7: "Отклонена",
        19: "Нарушение",
      },
      moment: moment,
      direction: [
        {
          valueDir: 1,
          show: false,
          name: "ВХОДЯЩИЙ",
        },
        {
          valueDir: 2,
          show: false,
          name: "ИСХОДЯЩИЙ",
        },
      ],
      type: [
        {
          valueTy: 1,
          show: false,
          name: "ПЕРВИЧНЫЙ",
        },
        {
          valueTy: 2,
          show: false,
          name: "ВТОРИЧНЫЙ",
        },
      ],
      // direction: {
      //   1: "ВХОДЯЩИЙ",
      //   2: "ИСХОДЯЩИЙ"
      // },
      // type: {
      //   1: "ПЕРВИЧНЫЙ",
      //   2: "ВТОРИЧНЫЙ"
      // },
      detail: {
        101: 'Задача "Как дела"',
        102: 'Задача "Пролонгация"',
        103: "Контроль качества",
        104: "Агент-сотрудник",
      },
      channel: [
        {
          valueCh: 1,
          name: "Интернет",
          show: false,
        },
        {
          valueCh: 2,
          name: "Рекомендация",
          show: false,
        },
        {
          valueCh: 3,
          name: "Агент",
          show: false,
        },
        {
          valueCh: 15,
          name: "Обзвон новой базы",
          show: false,
        },
        {
          valueCh: 16,
          name: "Парсинг",
          show: false,
        },
        // {
        //   value: 1,
        //   name: "Обзвон новой базы",
        //   show: true,
        // },
        {
          valueCh: 21,
          name: "Вторичная клиентская база",
          show: false,
        },
        {
          valueCh: 22,
          name: "Рассылка",
          show: false,
        },
        {
          valueCh: 23,
          name: "Агент-сотрудник",
          show: false,
        },
      ],
      // {
      //   1: "Интернет",
      //   2: "Рекомендация",
      //   3: "Агент",
      //   4: "Обзвон новой базы",
      //   15: "Обзвон новой базы",
      //   21: "Вторичная клиентская база",
      //   22: "Рассылка",
      //   23: "Агент-сотрудник",
      //   //31: "Вторичная клиентская база",
      // },
      cancel: {
        101: "Нецелевое касание: другой регион",
        102: "Нецелевое касание: б/у оборудование",
        103: "Нецелевое касание: экономически нецелесообразно",
        104: "Нецелевое касание: карты тахографа",
        105: "Нецелевое касание: консультация",
        106: "Нецелевое касание: недозвон",
        201: "Целевое касание: дорого",
        202: "Целевое касание: другое",
        //203: "другое",
      },
      communications: [
        {
          value: 1,
          name: "Интернет контекст звонок",
          show: false,
        },
        {
          value: 2,
          name: "Интернет контекст заявка с сайта",
          show: false,
        },
        {
          value: 3,
          name: "Интернет СЕО звонок",
          show: false,
        },
        {
          value: 4,
          name: "Интернет СЕО заявка с сайта",
          show: false,
        },
        {
          value: 5,
          name: "Звонок Исходящий",
          show: false,
        },
        {
          value: 6,
          name: "Письмо",
          show: false,
        },
        {
          value: 7,
          name: "Пришел в офис",
          show: false,
        },
        {
          value: 8,
          name: "Заявка через ЛК агента СРМ",
          show: false,
        },
        {
          value: 9,
          name: "Рассылка/Звонок",
          show: false,
        },
        {
          value: 10,
          name: "Заявка через ЛК клиента в СРМ",
          show: false,
        },
        {
          value: 11,
          name: "Заявка через ЛК агента-сотрудника",
          show: false,
        },
        {
          value: 12,
          name: "Заявка из отзыва с рейтингом",
          show: false,
        },
        {
          value: 13,
          name: "Заявка с сайта",
          show: false,
        },
        {
          value: 15,
          name: "Звонок Входящий",
          show: false,
        },
      ],
      channelDetailType: {
        1: "Наименование клиента",
        2: "Ниатменование рассылки",
        3: "ФИО агента-сотрудника",
        4: 'Пролонгация заказа, Задача "Пролонгация"',
        5: "Обзвон неактивных клиентов",
        6: "Обзвон клиентов по контролю качества",
        7: "Интернет контекст",
        8: "Интернет СЕО",
        9: "Наименование клиента",
        10: "Наименование агента",
        11: "Вид базы",
      },
      b: {
        1: "Логистический бизнес (перевозки)",
        2: "Строительный бизнес, спецтехника",
        3: "Среднегабаритная перевозка (городские перевозки)",
        4: "Собственная доставка (свой транспортный отдел)",
        5: "Другое",
      },
      business: "",
      business_dop: "",
      ts: "",
      sum: "",
      otkaz: false,
      cancel_id: 0,
      text_client: "",
      text_company: "",
      text_contact: "",
      text_price: "",
      text_comment: "",
      text_manager: "",
      explaintext: "",
      editPrice: {},
      timer: { time: null, color: null },
      companyList: [],
      contactList: [],
      priceList: [],
      managerList: [],
      st: {
        1: "новый",
        2: "назначен",
        3: "отказ",
      },
      newClient: {},
      showClientEdit: false,
      statusClasses: statusClasses,
    };
  },

  computed: {
    ...mapGetters([
      "s",
      "profile",
      "role",
      "roles",
      "lead",
      "touch",
      "garland",
      "selectTouchClients",
      "selectTouchCompanies",
      "selectTouchContacts",
      "selectManagers",
    ]),
    // availableChannels() {
    //   return extract(leadsByOther, this.touch.type, this.touch.direction);
    // },
    // availableChannelDetails() {
    //   return extract(
    //     leadsByOther,
    //     this.touch.type,
    //     this.touch.direction,
    //     this.touch.channel
    //   );
    // },
    // availableCommunicationTypes() {
    //   return extract(
    //     leadsByOther,
    //     this.touch.type,
    //     this.touch.direction,
    //     this.touch.channel,
    //     this.touch.channel_detail_type
    //   );
    // },
    canEditClient() {
      return ["Manager", "Logist", "Studio", "Hosd", "Check"].includes(this.role);
    },
    canShowClient() {
      return [
        this.canEditClient,
        this.touch.direction,
        // this.touch.type == 2,
      ].every(Boolean);
    },
    canAddClient() {
      return [
        this.canEditClient,
        // this.touch.direction,
        // this.touch.type == 1,
      ].every(Boolean);
    },
    canShowChannel() {
      return [
        this.touch.direction && this.touch.direction != 0,
        this.touch.type && this.touch.type != 0,
      ].every(Boolean);
    },
    canShowChannelDetailType() {
      return 21 == this.touch.channel && 2 == this.touch.direction;
    },
    canShowChannelDetailValue() {
      return ["4", "5", "6"].includes(this.touch.channel_detail_type);
    },
    canShowCommunicationType() {
      return [1, 2, 3, 4, 15, 16, 21, 22, 23].includes(this.touch.channel);
    },
    canCloseLead() {
      var set = new Set(this.touch.tasks.map((x) => x.status));
      return ![2, 3, 4].some((x) => set.has(x));
    },
  },

  methods: {
    ...mapActions([
      "createLeadFromTouch",
      "getTouch",
      "setLead",
      "setTouch",
      "kindOfLead",
      "findLeadClient",
      "setLeadClient",
      "delTouchClient",
      "addLeadClient",
      "clearLeadContactsCars",
      "setLeadCompany",
      "delLeadCompany",
      "setTouchContact",
      "delTouchContact",
      "updContact",
      "delLead",
      "delTouch",
      "setClient",
      "setClientContact",
      "showClient",
      "showContact",
      "setLeadManager",
      "delLeadManager",
      "setSettings",
      "addTask",
      "showTask",
      "sendCancel",
      "sendTouchCancel",
      "addOrder",
      "showLead",
      "editOrderId",
      "setClientBusiness",
      "setLeadChannel",
      "setTouchChannel",
      "changeBP",
      "getLead",
      "setLeadDirection",
      "setTouchDirection",
      "setLeadType",
      "setTouchType",
      "getGarladnsTouch",
      "setLeadDetail",
      "setClientTs",
      "setLeadSum",
      "setEvent1S",
      "setLeadChannelDetailType",
      "setLeadChannelDetailValue",
      "setLeadCommunicationType",
      "setTouchChannelDetailType",
      "setTouchCommunicationType",
      "setTouchChannelDetailValue",
      "addClientByLead",
      "goToLeadFromTouch",
      "goToBidNow",
      "goToInvoiceNow",
      "goToOrderNow",
      "setAllTouch",
      "tryChangeAll",
    ]),

    dClient() {
      this.contactList = null;
      this.tsList = null;
      return this.delTouchClient();
    },

    close() {
      this.getTouch();
      this.s.popup = null;
    },

    closeContact() {
      this.getTouch();
      this.s.popup = null;
    },

    onChangeBP() {
      //НАЧИНАЕМ МАГИЮ АВТОМАТИЧЕСКОГО РАССТАВЛЕНИЯ
      console.log("this.touch", this.touch);
      console.log("this.touch.business_proc", this.touch.business_proc);

      let bp = parseInt(this.touch.business_proc);
      this.communications.forEach((communication) => {
        communication.show = false;
      });
      this.type.forEach((t) => {
        t.show = false;
      });
      this.direction.forEach((d) => {
        d.show = false;
      });
      this.channel.forEach((c) => {
        c.show = false;
      });

      // ПРОЛОНГАЦИЯ ТАХОГРАФЫ (СКЗИ) 1 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "1":
      if (bp == 1) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }
      // ПРОЛОНГАЦИЯ НАСТРОЙКИ ЕСТР 2 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "2":
      if (bp == 2) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }
      // ПРОЛОНГАЦИЯ ПРОПУСКА 3 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "3":
      if (bp == 3) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // ПРОЛОНГАЦИЯ КАРТЫ 4 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "4":
      if (bp == 4) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // КОНТРОЛЬ КАЧЕСТВА 5 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "5":
      if (bp == 5) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // РЕАНИМАЦИЯ НЕАКТИВНЫХ 6 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "6":
      if (bp == 6) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // РЕАНИМАЦИЯ КЛИЕНТОВ БЕЗ ЗАКАЗОВ 7 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "7":
      if (bp == 7) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // РЕКЛАМАЦИЯ 8 - ВТ 2 - ВКБ 21 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
      // case "8":
      if (bp == 8) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 1;
        this.touch.communication_type = 15;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 1).show = true;
        this.communications.find((item) => item.value === 15).show = true;
        this.communications.find((item) => item.value === 6).show = true;
      }

      // КАК ДЕЛА 9 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "9":
      if (bp == 9) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // ОБЩИЙ 10 -
      // 1 - ПЕР 1 - РАСС 22 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
      // 2 - ВТ 2 - ВКБ 21 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
      // case "9":
      if (bp == 10) {
        this.touch.type = 0;
        this.touch.channel = 0;
        this.touch.direction = 0;
        this.touch.communication_type = 0;

        this.type.find((item) => item.valueTy === 1).show = true;
        this.type.find((item) => item.valueTy === 2).show = true;

        this.channel.find((item) => item.valueCh === 22).show = true;
        // this.channel.find((item) => item.valueCh === 21).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;

        this.direction.find((item) => item.valueDir === 1).show = true;

        this.communications.find((item) => item.value === 15).show = true;
        this.communications.find((item) => item.value === 7).show = true;
        this.communications.find((item) => item.value === 6).show = true;
        this.communications.find((item) => item.value === 13).show = true;
      }

      // А\Б МОНИТОРИНГ 11 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
      // case "11":
      if (bp == 11) {
        this.touch.type = 2;
        this.touch.channel = 21;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 2).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // АГЕНТ 12 - ВТ 2 - АГЕНТ СОТРУНДИК 23 - ВХ 1 - АГЕНТ 11
      // case "12":
      if (bp == 12) {
        this.touch.type = 1;
        this.touch.channel = 3;
        this.touch.direction = 1;
        this.touch.communication_type = 8;

        this.type.find((item) => item.valueTy === 1).show = true;
        this.channel.find((item) => item.valueCh === 3).show = true;
        this.direction.find((item) => item.valueDir === 1).show = true;
        this.communications.find((item) => item.value === 8).show = true;
      }

      // РЕКОМЕНДАЦИИ 13 - П 1 - РЕКОМЕНД 2 - ВХОД 1 - ПРИШЕЛ 7
      // case "13":
      if (bp == 13) {
        this.touch.type = 1;
        this.touch.channel = 2;
        this.touch.direction = 1;
        this.touch.communication_type = 7;

        this.type.find((item) => item.valueTy === 1).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.direction.find((item) => item.valueDir === 1).show = true;
        this.communications.find((item) => item.value === 7).show = true;
      }

      // ИНТЕРНЕТ 14 - П 1 - ИНТ 1 - ВХОД 1 - ПРИШЕЛ 7
      // case "14":
      if (bp == 14) {
        this.touch.type = 1;
        this.touch.channel = 1;
        this.touch.direction = 1;
        this.touch.communication_type = 7;

        this.type.find((item) => item.valueTy === 1).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;
        this.direction.find((item) => item.valueDir === 1).show = true;
        this.communications.find((item) => item.value === 7).show = true;
        this.communications.find((item) => item.value === 13).show = true;
      }

      // ХОЛОДНАЯ БАЗА 15 - П 1 - ОБЗВ Н Б 15 - ИСХ 2 - ИСХ ЗВ 5
      // case "15":
      if (bp == 15) {
        this.touch.type = 1;
        this.touch.channel = 0;
        this.touch.direction = 2;
        this.touch.communication_type = 5;

        this.type.find((item) => item.valueTy === 1).show = true;
        this.channel.find((item) => item.valueCh === 15).show = true;
        this.channel.find((item) => item.valueCh === 16).show = true;
        this.direction.find((item) => item.valueDir === 2).show = true;
        this.communications.find((item) => item.value === 5).show = true;
      }

      // await this.trySetLeadType(this.touch.type);
      // await this.trySetLeadDirection(this.touch.direction);
      // await this.trySetLeadChannel(this.touch.channel);
      // await this.setTouchCommunicationType(this.touch.communication_type);
      //КОНЧАЕМ МАГИЮ АВТОМАТИЧЕСКОГО РАССТАВЛЕНИЯ
      // this.changeBP(this.touch.business_proc);

      this.setAllTouch({
        business_proc: this.touch.business_proc,
        channel: this.touch.channel,
        communication_type: this.touch.communication_type,
        type: this.touch.type,
        direction: this.touch.direction,
      });
    },

    tryChangeAllFunc() {
      if (confirm("Подтвердите действие каскадного изменения!")) {
        this.tryChangeAll({
          business_proc: this.touch.business_proc,
          channel: this.touch.channel,
          communication_type: this.touch.communication_type,
          type: this.touch.type,
          direction: this.touch.direction,
        });
      }
    },

    // КОМПАНИЯ
    findCompany() {
      // console.log("findCompany: ", this.text_company);
      if (this.text_company != "") {
        this.companyList = this.selectTouchCompanies.filter((item) => {
          console.log("item", item);
          let name = null;
          let full = null;
          if (item.name != null) {
            name =
              item.name
                .toLowerCase()
                .indexOf(this.text_company.toLowerCase()) !== -1;
          }
          if (item.full != null) {
            full =
              item.full
                .toLowerCase()
                .indexOf(this.text_company.toLowerCase()) !== -1;
          }
          if (name || full) {
            return true;
          }
          return false;
        });
      } else {
        this.companyList = this.selectTouchCompanies;
      }
    },

    pickCompany(item) {
      this.setLeadCompany(item);
      this.text_contact = "";
    },

    // КОНТАКТ
    findContact() {
      // console.log("findContact: ", this.text_contact);
      if (this.text_contact != "") {
        this.contactList = this.selectTouchContacts.filter((item) => {
          console.log("item", item);
          let name = null;
          let secondname = null;
          if (item.name != null) {
            name =
              item.name
                .toLowerCase()
                .indexOf(this.text_contact.toLowerCase()) !== -1;
          }
          if (item.secondname != null) {
            secondname =
              item.secondname
                .toLowerCase()
                .indexOf(this.text_contact.toLowerCase()) !== -1;
          }
          if (name || secondname) {
            return true;
          }
          return false;
        });
      } else {
        this.contactList = this.selectTouchContacts;
      }
    },

    pickContact(item) {
      this.setTouchContact(item);
      this.text_contact = "";
    },

    showContactfromLead(contact) {
      this.s.back = "/touch/edit";
      this.setSettings(this.s);
      this.showContact(contact);
    },

    findManager() {
      this.managerList = this.selectManagers.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.text_manager.toLowerCase()) !==
          -1
      );
    },

    Order() {
      let formData = new FormData();
      formData.append("touch_id", this.touch.id);
      formData.append("client_id", this.touch.client_id);
      this.addOrder(formData);
    },

    CLFT() {
      let formData = new FormData();
      formData.append("touch_id", this.touch.id);
      // formData.append("client_id", this.touch.client_id);
      this.createLeadFromTouch(formData);
    },

    Tmr() {
      if (this.touch.timer) {
        let date = moment(this.touch.timer);
        let now = moment() - moment().utcOffset() * 60000 + 180 * 60000; // временная зона
        this.timer.time = moment.utc(date - now).format("HH:mm:ss");

        let t = date - now;

        if (t > 0) {
          this.timer.color = "1";
        } else {
          this.timer.color = "7";
          t = t * -1;
        }
        let hours = Math.floor(t / (1000 * 60 * 60));
        if (hours < 10) {
          hours = "0" + hours;
        }
        let minutes = Math.floor((t / (1000 * 60)) % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        let seconds = Math.floor((t / 1000) % 60);
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        this.timer.time = hours + ":" + minutes + ":" + seconds;
      } else {
        this.timer.time = null;
      }
    },
    // extract: extract,
    async trySetLeadDirection(value) {
      if (value == 0) {
        // await this.setClient(0);
        await this.trySetLeadChannel(0);
        // await this.dClient();
      }
      await this.setTouchDirection(value);
      // var channels = extract(
      //   leadsByOther,
      //   this.touch.type,
      //   this.touch.direction
      // );
      var channels = this.channel;
      if (channels.length === 1)
        await this.trySetLeadChannel(channels[0].valueCh);
      // if (value == 2) await this.setTouchCommunicationType(5);
    },
    async trySetLeadType(value) {
      if (parseInt(this.touch.business_proc) == 10) {
        this.channel.forEach((channels) => {
          channels.show = false;
        });

        this.communications.find((item) => item.value === 15).show = true;
        this.communications.find((item) => item.value === 7).show = true;
      }
      if (parseInt(value) == 1 && parseInt(this.touch.business_proc) == 10) {
        // this.channel.map((item) => item).show = true;
        this.channel.find((item) => item.valueCh === 22).show = true;
        // this.channel.find((item) => item.valueCh === 21).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;

        // this.touch.channel = 22;
        // await this.trySetLeadChannel(22);
      }
      if (parseInt(value) == 2 && parseInt(this.touch.business_proc) == 10) {
        // this.channel.map((item) => item).show = true;
        this.channel.find((item) => item.valueCh === 22).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;

        // this.touch.channel = 21;
        // await this.trySetLeadChannel(21);
      }

      if (value == 0) {
        // await this.setClient(0);
        await this.trySetLeadChannel(0);
        await this.trySetLeadDirection(0);
      }
      await this.setTouchType(value);
    },

    async trySetLeadChannel(value) {
      console.log("value", value);
      console.log("communications", this.communications);
      console.log("touch.communication_type", this.touch.communication_type);

      if (value == 0) {
        console.log(
          "Сбрасываем",
          this.touch.channel_detail_type,
          this.touch.channel_detail_value
        );
        await this.trySetLeadChannelDetailType(0);
      }
      await this.setTouchChannel(value);

      if (this.touch.direction == 2) await this.setTouchCommunicationType(5);
      if (this.touch.channel == 3) await this.setTouchCommunicationType(8);
    },
    //async trySetLeadChannel(value){},
    async trySetLeadChannelDetailType(value) {
      if (value == 0) {
        console.log("Сам сброс");
        this.touch.communication_type = 0;
        this.touch.channel_detail_value = "";
        var rt = await this.setTouchCommunicationType(0);
        var rv = await this.setTouchChannelDetailValue("");
        console.log("Результаты: ", rt.data, rv.data);
      }
      await this.setTouchChannelDetailType(value);
    },
    async addNewClient() {
      var client = await this.addClientByLead();
      console.log("Новый клиент", client);
      await this.setLeadClient(client.id);
      await this.setClient(client);
      this.showClientEdit = true;
    },
    async editNewClient() {
      await this.setClient(this.touch.client);
      this.showClientEdit = true;
    },
    async clientEditClose() {
      await this.getTouch();
      this.showClientEdit = false;
    },
    tryCreateOrder() {
      if (!this.canCloseLead)
        alert("Нельзя создать лид если задачи не завершены");
      else if (this.touch.business_proc == 0)
        alert("Нельзя создать лид если не выбран Бизнес процесс!");
      else if (!this.touch.type)
        alert("Нельзя создать лид если не выбран Вид касания!");
      else if (!this.touch.direction)
        alert("Нельзя создать лид если не выбрано Направление!");
      else if (!this.touch.channel)
        alert("Нельзя создать лид если не выбран Канал привлечения!");
      else if (!this.touch.client_id)
        alert("Нельзя создать лид если не выбран Клиент!");
      else if (
        (this.touch.contact_id == null || this.touch.contact_id == 0) &&
        this.touch.type == 2
      )
        alert("Нельзя создать лид если не выбран Контакт!");
      else if (Number(this.touch.communication_type == 0))
        alert("Нельзя создать лид если не выбран Вид коммуникации!");
      else if (!this.touch.who)
        alert("Нельзя создать лид если у касания нет Создателя!");
      else return this.CLFT();
    },
    tryCansel() {
      if (!this.touch.type) {
        alert("Отказ невозможен. Не указан вид касания!");
        return 0;
      }
      if (!this.touch.direction) {
        alert("Отказ невозможен. Не указано направление касания!");
        return 0;
      }
      if (!this.touch.channel) {
        alert("Отказ невозможен. Не указан канал привлечения касания!");
        return 0;
      }
      if (!this.touch.communication_type) {
        alert("Отказ невозможен. Не указан вид коммуникации касания!");
        return 0;
      }

      if (this.canCloseLead) {
        this.otkaz = true;
      } else alert("Нельзя оформить отказ если задачи не завершены");
    },
    tryDelLead() {
      if (this.canCloseLead) return this.delTouch();
      else alert("Нельзя удалить касание если задачи не завершены");
    },
    tryAddTask(data) {
      if (this.canCloseLead) return this.addTask(data);
      else alert("В касании должна быть только одна незавершенная задача");
    },
    toggleGarl(garlShow) {
      if (garlShow == "showTouches") {
        this.showTouches = !this.showTouches;
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showLeads") {
        this.showTouches = false;
        this.showLeads = !this.showLeads;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showZayavka") {
        this.showTouches = false;
        this.showZayavka = !this.showZayavka;
        this.showSchet = false;
        this.showAnketa = false;
        this.showLeads = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showSchet") {
        this.showTouches = false;
        this.showSchet = !this.showSchet;
        this.showAnketa = false;
        this.showinvoice = false;
        this.showLeads = false;
        this.showZayavka = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showAnketa") {
        this.showTouches = false;
        this.showAnketa = !this.showAnketa;
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showinvoice") {
        this.showTouches = false;
        this.showinvoice = !this.showinvoice;
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showOrderLet") {
        this.showTouches = false;
        this.showinvoice = false;
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showOrderLet = !this.showOrderLet;
      }
    },

    goToTouch(touch) {
      this.goToTouchFromLead(touch);
    },
    goToLead(lead) {
      this.goToLeadFromTouch(lead);
    },
    goToBid(bid) {
      this.goToBidNow(bid);
    },
    goToInvoice(invoice) {
      this.goToInvoiceNow(invoice);
    },
    goToOrder(order) {
      this.goToOrderNow(order);
    },
  },

  async mounted() {
    await this.getTouch();
    await this.getGarladnsTouch();

    window.setInterval(() => {
      this.Tmr();
      this.showGarland = true;
    }, 500);

    if (this.touch.business_proc == 1) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 1");
    }
    // ПРОЛОНГАЦИЯ НАСТРОЙКИ ЕСТР 2 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "2":
    if (this.touch.business_proc == 2) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 2");
    }
    // ПРОЛОНГАЦИЯ ПРОПУСКА 3 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "3":
    if (this.touch.business_proc == 3) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 3");
    }

    // ПРОЛОНГАЦИЯ КАРТЫ 4 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "4":
    if (this.touch.business_proc == 4) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 4");
    }

    // КОНТРОЛЬ КАЧЕСТВА 5 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "5":
    if (this.touch.business_proc == 5) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 5");
    }

    // РЕАНИМАЦИЯ НЕАКТИВНЫХ 6 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "6":
    if (this.touch.business_proc == 6) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 6");
    }

    // РЕАНИМАЦИЯ КЛИЕНТОВ 7 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "7":
    if (this.touch.business_proc == 7) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 7");
    }

    // РЕКЛАМАЦИЯ 8 - ВТ 2 - ВКБ 21 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
    // case "8":
    if (this.touch.business_proc == 8) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 1).show = true;
      this.communications.find((item) => item.value === 15).show = true;
      this.communications.find((item) => item.value === 6).show = true;

      // console.log("БП 8");
    }

    // КАК ДЕЛА 9 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "9":
    if (this.touch.business_proc == 9) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 9");
    }

    // ОБЩИЙ 10 -
    // 1 - ПЕР 1 - РАСС 22 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
    // 2 - ВТ 2 - ВКБ 21 - ВХОД 1 - ВХОД ЗВ 15 \ ПРИШЕЛ В ОФИС 7
    // case "9":
    if (this.touch.business_proc == 10) {
      this.type.find((item) => item.valueTy === 1).show = true;
      this.type.find((item) => item.valueTy === 2).show = true;

      if (this.touch.type == 1) {
        // this.channel.map((item) => item).show = true;
        this.channel.find((item) => item.valueCh === 22).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;
      }
      if (this.touch.type == 2) {
        // this.channel.map((item) => item).show = true;
        this.channel.find((item) => item.valueCh === 22).show = true;
        this.channel.find((item) => item.valueCh === 21).show = true;
        this.channel.find((item) => item.valueCh === 2).show = true;
        this.channel.find((item) => item.valueCh === 1).show = true;

        // this.touch.channel = 21;
        // await this.trySetLeadChannel(21);
      }

      // this.channel.find((item) => item.valueCh === 22).show = true;
      // this.channel.find((item) => item.valueCh === 21).show = true;
      // this.channel.find((item) => item.valueCh === 2).show = true;
      // this.channel.find((item) => item.valueCh === 1).show = true;

      this.direction.find((item) => item.valueDir === 1).show = true;

      this.communications.find((item) => item.value === 15).show = true;
      this.communications.find((item) => item.value === 7).show = true;
      this.communications.find((item) => item.value === 6).show = true;
      this.communications.find((item) => item.value === 13).show = true;

      // console.log("БП 10");
    }

    // А\Б МОНИТОРИНГ 11 - ВТ 2 - ВКБ 21 - ИСХ 2 - ИСХ ЗВ 5
    // case "11":
    if (this.touch.business_proc == 11) {
      this.type.find((item) => item.valueTy === 2).show = true;
      this.channel.find((item) => item.valueCh === 21).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 11");
    }

    // АГЕНТ 12 - ВТ 2 - АГЕНТ СОТРУНДИК 23 - ВХ 1 - АГЕНТ 11
    // case "12":
    if (this.touch.business_proc == 12) {
      this.type.find((item) => item.valueTy === 1).show = true;
      this.channel.find((item) => item.valueCh === 3).show = true;
      this.direction.find((item) => item.valueDir === 1).show = true;
      this.communications.find((item) => item.value === 8).show = true;

      // console.log("БП 12");
    }

    // РЕКОМЕНДАЦИИ 13 - П 1 - РЕКОМЕНД 2 - ВХОД 1 - ПРИШЕЛ 7
    // case "13":
    // if (this.touch.business_proc == 13) {
    //   this.type.find((item) => item.valueTy === 1).show = true;
    //   this.channel.find((item) => item.valueCh === 2).show = true;
    //   this.direction.find((item) => item.valueDir === 1).show = true;
    //   this.communications.find((item) => item.value === 7).show = true;

    //   // console.log("БП 13");
    // }

    // ИНТЕРНЕТ 14 - П 1 - ИНТ 1 - ВХОД 1 - ПРИШЕЛ 7
    // case "14":
    if (this.touch.business_proc == 14) {
      this.type.find((item) => item.valueTy === 1).show = true;
      this.channel.find((item) => item.valueCh === 1).show = true;
      this.direction.find((item) => item.valueDir === 1).show = true;
      this.communications.find((item) => item.value === 7).show = true;
      this.communications.find((item) => item.value === 13).show = true;

      // console.log("БП 14");
    }

    // ХОЛОДНАЯ БАЗА 15 - П 1 - ОБЗ Н Б 4 - ИСХ 2 - ИСХ ЗВ 5
    // case "15":
    if (this.touch.business_proc == 15) {
      this.type.find((item) => item.valueTy === 1).show = true;
      this.channel.find((item) => item.valueCh === 15).show = true;
      this.channel.find((item) => item.valueCh === 16).show = true;
      this.direction.find((item) => item.valueDir === 2).show = true;
      this.communications.find((item) => item.value === 5).show = true;

      // console.log("БП 15");
    }

    // console.log("Просто поставил");
    // console.log("тач", this.touch);

    this.communications.find(
      (item) => item.value === this.touch.communication_type
    ).show = true;

    window.DEBUG_LEAD = this;
  },
};
</script>
<style>
.new_lead_task {
  color: gray;
}
.robot_lead_task {
  color: blue;
}
.appoint_lead_task {
  color: green;
}
.started_lead_task {
  color: darkviolet;
}
.done_lead_task {
  color: brown;
}
.finished_lead_task {
  color: olive;
}
.violate_lead_task {
  color: red;
}

.double-flex {
  display: flex;
}
.-ml-6 {
  margin-left: -1.5rem;
}
.brs1px {
  border-right: 1px solid #d8dedf;
}
.select-bp {
  padding: 10px 15px;
  width: 100%;
  background: transparent;
}

.absolute-list {
  width: 200px;
  position: absolute;
  top: 90%;
  right: -200px;
  text-align: left;
  background: #fff;
  border-radius: 5px;
  padding: 10px 0px;
  box-shadow: 0 0 5px #00000020;
  z-index: 999;
}
.last-list {
  right: 0 !important;
}
.absolute-list p {
  padding: 0 15px;
  margin-bottom: 5px;
  text-align: center;
}
.absolute-list a:last-child {
  margin-bottom: 0px;
}
.absolute-list a {
  padding: 3px 15px;
  margin-bottom: 5px;
  transition: 0.3s ease;
  width: 100%;
  display: block;
  text-align: center;
  cursor: pointer;
}
.absolute-list a:hover {
  background: rgb(236, 236, 236);
}
</style>
